<template lang="pug">
.context
  section
    h5 スマホにインストール出来ます!
    p Android,iOS両対応です.画面下orメニューからインストール出来ます.
    .row
      .columns.five
        img(src="@/assets/img/android.webp", alt="Android_Screen", width="100%")
      .columns.five
  section
    h5 PCでもワンクリックでDL可能
    p 以下のブックマークレットをお使いのブラウザに登録することで,開いてるツイートのリンクをURLの入力すること無く,動画をダウンロードすることが出来ます!
    pre javascript:(function(){const url=location.href;window.location.href="https://tools.ic731.net/twiloader?url="+url;})();
    .future
      h5 スマホの共有メニューから直接DLできます
      p Twitterの共有メニュー経由でURLを入力せずに動画をダウンロードすることが出来ます.(まだ非対応)
  section#howto
    h4 使い方
    details(open) 
      summary ツイートのURLを入力します
      p Twitterアプリの共有ボタンやアドレスバーから保存したい動画の”ツイートURL”をコピーして,当サイトトップに貼り付けて下さい.
    details(open)
      summary ボタンを押したらDLされます
      p 余計なダイアログや設定・広告無しにボタンを押したら速攻ダウンロードされます.
      p ※ファイル名も事前に[保存設定]から指定できます.
  section
    h4 FAQ / 免責事項
    details(open) 
      summary 公式アカウントの動画がDL出来ない
      p Twitter上の公式アカウントが投稿した動画のダウンロードは現在まだ対応しておりません.開発者のやる気を上げるためにもし良いなと思ったらシェアして下さい!!
    details(open)
      summary 注意すべき事項は？
      p 違法にアップロードされた動画を違法であると知りながらダウンロードする行為は著作権法により禁止されています.
      b 違法DLの幇助の為に公開しているサービスではないと共に,開発者及び当サイトは一切の責任を負わない事にご注意下さい.
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss" scoped>
.context {
  padding-top: 2rem;
}
section {
  margin-top: 2rem;
}

pre {
  background-color: #000000;
  padding: 1rem;
  color: #ffffff;
  border-radius: 0.5rem;
  overflow: auto;
}

.future {
  background-color: rgba($color: #000000, $alpha: 0.25);
}

details[open] summary ~ * {
  animation: open 0.3s ease-in-out;
}

@keyframes open {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
details summary::-webkit-details-marker {
  display: none;
}

details summary {
  width: 100%;
  padding: 0.5rem 0;
  border-top: 1px solid black;
  position: relative;
  cursor: pointer;
  font-weight: 300;
  list-style: none;
  font-size: 1.75rem;
}

details summary:after {
  content: "+";
  color: black;
  position: absolute;
  line-height: 0;
  margin-top: 1.25rem;
  right: 0;
  font-weight: 200;
  transform-origin: center;
  transition: 200ms linear;
}
details[open] summary:after {
  transform: rotate(45deg);
  font-size: 2rem;
}
details summary {
  outline: 0;
}
</style>
